var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconBtnDeleteTable = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M4 6.6H5.77778M5.77778 6.6H20M5.77778 6.6V19.2C5.77778 19.6774 5.96508 20.1352 6.29848 20.4728C6.63187 20.8104 7.08406 21 7.55556 21H16.4444C16.9159 21 17.3681 20.8104 17.7015 20.4728C18.0349 20.1352 18.2222 19.6774 18.2222 19.2V6.6M8.44444 6.6V4.8C8.44444 4.32261 8.63175 3.86477 8.96514 3.52721C9.29854 3.18964 9.75073 3 10.2222 3H13.7778C14.2493 3 14.7015 3.18964 15.0349 3.52721C15.3683 3.86477 15.5556 4.32261 15.5556 4.8V6.6M10.2222 11.1V16.5M13.7778 11.1V16.5",
  stroke: "#3E4248",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconBtnDeleteTable);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon_btn_delete_table.479246b2acd8390dda165a7a3c7b15aa.svg";